import { useRouter } from "@core/Api/useRouter";
import { useMemo } from "react";

export const useToolbarMode = () => {
	const router = useRouter();

	return useMemo(() => router.query.mode !== "markdown", [router.query.mode]);
};
